module.exports = __webpack_public_path__ + "img/web_dev.0583ab09.png";